export const SUCCESS = 'success'
export const WARNING = 'warning'
export const ERROR = 'error'
